import React from 'react';
import { Confirmation } from '../../../components/confirmation/Confirmation';

interface ArchiveConfirmationProps {
  open: boolean;
  operationTitle: string;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
}

export const ArchiveConfirmation: React.FC<ArchiveConfirmationProps> = ({
  open,
  operationTitle,
  onConfirm,
  onCancel
}) => {
  return (
    <Confirmation
      open={open}
      title="Archive operation"
      accessibleTitle="Operation Archive Confirmation"
      message={`Archiving this operation will remove "${operationTitle}" from the active list but preserve all data. Are you sure?`}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText="Archive"
      cancelText="Cancel"
    />
  );
};